import { defineRecipe } from '@chakra-ui/react';

// v2's function variants read `colorScheme` from props; v3 expresses the same
// thing statically via colorPalette tokens. `mode(light, dark)` collapsed to
// its light value — no color mode is configured anywhere in ui-core or its
// consumers, so the dark branch never ran.
export const badgeVariants = {
  solid: {
    bg: 'colorPalette.500',
    color: 'white',
  },
  subtle: {
    bg: 'colorPalette.100',
    color: 'colorPalette.800',
  },
  outline: {
    color: 'colorPalette.500',
    // v2 computed the same colour for text and ring; currentColor keeps them in sync
    boxShadow: 'inset 0 0 0px 1px currentColor',
  },
} as const;

const badgeRecipe = defineRecipe({
  base: {
    colorPalette: 'gray',
    px: 1,
    textTransform: 'uppercase',
    fontSize: 'xs',
    borderRadius: 'sm',
    fontWeight: 'bold',
  },
  variants: {
    variant: badgeVariants,
  },
  defaultVariants: {
    variant: 'subtle',
  },
});

export default badgeRecipe;
